import React from "react";
import { InputBaseProps } from "..";
import { SanityInputTermsAndConditionsProps } from "../../../models/form/SanityFormInputField";
import ControlledCheckbox from "../../ControlledInputs/ControlledCheckbox";
import PortableText from "../../PortableText";
import { PortableTextColorTheme } from "../../PortableText/PortableText";
import { useFieldValidator } from "../Validation";
import InputContainer from "./InputContainer";
import { useFieldCustom } from "./useFieldCustom";

export type TermsAndConditionsInputProps =
  InputBaseProps<SanityInputTermsAndConditionsProps>;

const TermsAndConditionsInput = (props: TermsAndConditionsInputProps) => {
  const {
    description,
    inputContainerVariant,
    name,
    label = "",
    readonly,
    validation
  } = props;

  const validator = useFieldValidator(validation);

  const [field, meta] = useFieldCustom({
    name,
    validate: validator,
    type: "checkbox"
  });

  return (
    <InputContainer meta={meta} variant={inputContainerVariant}>
      <>
        {!!description?.length && (
          <div className="mb-6 lg:mb-10 text-brand-primary-dim">
            <PortableText
              _rawBody={description}
              addSections={false}
              colorTheme={PortableTextColorTheme.None}
              elementClasses={{
                a: "text-inherit-size font-bold",
                li: "mb-3 last:mb-0",
                p: "text-sm text-current",
                ul: "text-sm"
              }}
            />
          </div>
        )}
        <ControlledCheckbox
          {...field}
          error={meta.touched && !!meta.error}
          label={label}
          readonly={readonly}
        />
      </>
    </InputContainer>
  );
};

export default TermsAndConditionsInput;

